define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class bdcTabacPresseService
     */
    function BDCTabacPresseService(orderService) {
        var self = this;

        self.leaserOptionsFilter = function leaserOptionsFilter(option) {
            var typeValues = ['SCANUP', 'DEFAUT', 'ACCESSOIRE_CAISSE', 'IMPRIMANTE', 'EXTENSION', 'TIROIR_CAISSE'];
            return option.optionType ? typeValues.indexOf(option.optionType.code) > -1 : false;
        };

        self.leaserPrestationsFilter = function (option) {
            var typeValues = ['PRESTATION'];
            return option.optionType ? typeValues.indexOf(option.optionType.code) > -1 : false;
        };

        self.leaserOptionsOrder = function leaserOptionsOrder(option) {
            switch (option.optionType.code) {
                case 'TIROIR_CAISSE':
                    return 0;
                case 'ACCESSOIRE_CAISSE':
                    return 1;
                case 'IMPRIMANTE':
                    return 2;
                case 'SCANUP':
                    return 3;
                case 'DEFAUT':
                    return 4;
                case 'EXTENSION':
                    return 5;
                default:
                    return 10;
            }
        };

        self.getFilteredLeaserOptions = function getFilteredLeaserOptions(order) {
            var filteredLeaserOptions = order.options
                .filter(orderService.checkOptionKey('billingTypeCode', 'LEASER_ACHAT'))
                // Filter optionTypes
                .filter(self.leaserOptionsFilter)
                // Remove any additional option (printers, ..)
                .filter(function(option) {
                    return option.isAdditional === false;
                });
            // Scanup exception it scanup contract is purchase on a rental order
            if (order.scanupContractType.code === 'ACHAT' && order.contract.contractType.code !== 'ACHAT') {
                filteredLeaserOptions = filteredLeaserOptions.filter(function(option) {
                    return option.optionType.code !== 'SCANUP';
                });
            }

            return filteredLeaserOptions;
        };

        self.getFilteredLeaserPrestations = function (order) {
            var filteredLeaserPrestations = order.options
                .filter(orderService.checkOptionKey('billingTypeCode', 'LEASER_ACHAT'))
                // Filter optionTypes
                .filter(self.leaserPrestationsFilter)
                // Remove any additional option (printers, ..)
                .filter(function(option) {
                    return option.isAdditional === false;
                });

            if (order.installContractType.code === 'ACHAT' && order.contract.contractType.code !== 'ACHAT') {
                filteredLeaserPrestations = filteredLeaserPrestations.filter(function(option) {
                    return !['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO'].includes(option.code) ;
                });
            }

            if (order.cateringSupportContractType.code === 'ACHAT' && order.contract.contractType.code !== 'ACHAT') {
                filteredLeaserPrestations = filteredLeaserPrestations.filter(function(option) {
                    return ['RESTAURATION-ESSENTIEL', 'RESTAURATION-PREMIUM', 'RESTAURATION-ULTIMATE'].indexOf(option.code) === -1;
                });
            }
            return filteredLeaserPrestations;
        };

        self.getFilteredPurchasePrestations = function (order) {
            var filteredPurchasePrestations = order.options
                .filter(orderService.checkOptionKey('billingTypeCode', 'LEASER_ACHAT'))
                // Filter optionTypes
                .filter(self.leaserPrestationsFilter)
                // Remove any additional option (printers, ..)
                .filter(function(option) {
                    return option.isAdditional === false;
                });

            if (order.installContractType.code !== 'ACHAT' && order.contract.contractType.code !== 'ACHAT') {
                filteredPurchasePrestations = filteredPurchasePrestations.filter(function(option) {
                    return !['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO'].includes(option.code);
                });
            }

            if (order.cateringSupportContractType.code !== 'ACHAT' && order.contract.contractType.code !== 'ACHAT') {
                filteredPurchasePrestations = filteredPurchasePrestations.filter(function(option) {
                    return ['RESTAURATION-ESSENTIEL', 'RESTAURATION-PREMIUM', 'RESTAURATION-ULTIMATE'].indexOf(option.code) === -1;
                });
            }
            return filteredPurchasePrestations;
        };

        return self;
    }

    BDCTabacPresseService.$inject = ['orderService'];

    angular.module('app.bdc.reports.bdcTabacPresseService', []).factory('bdcTabacPresseService', BDCTabacPresseService);
});
